import { useQuery } from "@tanstack/react-query";

import { packagesApi } from "../../api/packages";

export function useMyPackage() {
  return useQuery({
    queryKey: ["client", "package"],
    queryFn: ({ signal }) => packagesApi.mine(signal),
  });
}
